import { IntegrationType } from '@shared/enums/IntegrationType';
import { IConnectorValidation } from '@shared/services/api/dashboard/integrations-service/integrations-model';
import { IGetUserProvisioning, IUserProvisioning } from '@shared/services/api/dashboard/user-provisionings-service/user-provsionings-model';
import { IPermission } from '@shared/services/api/legacy/settings-service/setting-model';
import { ITenant } from '@shared/services/api/legacy/users-service/user-model';

export class Profile {
    constructor(public id: string = null, public name: string = null, public firstName: string = null) { }

    public languageId: string;
    public cultureInfoId: string;
    public pictureUrl: string;
    public jobTitle: string;
    public pending: boolean;
    public aadRemoteId: string;
    public isSupport: boolean;
    public tenants: ITenant[];
    public localeId: string;

    public get usesMsWorkAccount(): boolean {
        return !!this.aadRemoteId;
    }

    public get usesIdeskIdentityAccount(): boolean {
        return this.aadRemoteId == null;
    }
}

export class Tenants {
    constructor(public tenants: ITenant[] = []) { }
}

export class IvdEnvironment {

    constructor(public crms: IConnectorValidation[] = [], public tenantSettings: IPermission = null, public userProvisioning: IGetUserProvisioning = null) { }

    /**
     * returns true if the current environment has the crm identified by
     * type enabled.
     */
    public hasCrmEnabled(type: IntegrationType): boolean {
        const hasIntegrationEnabled = this.crms?.find(crm => crm.destinationCrm === type && crm.syncEnabled);
        return hasIntegrationEnabled != null;
    }

    /**
     * returns true if the current environment has at least one crm enabled in a given array of integration types.
     */
    public hasAnyCrmEnabled(types: IntegrationType[]): boolean {

        const enabled = types.find(type => {
            const hasIntegrationEnabled  = this.crms?.find(crm => crm.destinationCrm === type && crm.syncEnabled);
            return hasIntegrationEnabled != null;
        });

        return enabled != null;
    }

    /**
     * searches for the first crm that is enabled and returns it as an integration type.
     * Returns Undefined in case all crms are disabled.
     * */
    public getFirstEnabledCrmIntegration(): IntegrationType {
        const hasIntegrationEnabled  = this.crms?.find(crm => crm.syncEnabled);

        if (hasIntegrationEnabled != null) {
            switch (hasIntegrationEnabled.destinationCrm) {
                case IntegrationType.Salesforce.toString() : return IntegrationType.Salesforce;
                case IntegrationType.Hubspot.toString() : return IntegrationType.Hubspot;
                case IntegrationType.Dynamics.toString() : return IntegrationType.Dynamics;
                default: return IntegrationType.Undefined;
            }
        }

        return IntegrationType.Undefined;
    }
}
